module.exports = __webpack_public_path__ + "media/images/icons/check-white-3f47bfcf253e84dc9fd9381ae496b2c2.svg";